<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>Una victoria gloriosa</h2>
    <img @click="imageClicked(0)" src="galerias/sala2/S2_G6.jpg" class="mainphoto"/>
    <p class="photo-description">Título: <b>Zacapoaxtla abatiendo Zuavos</b><br>
      Autor: desconocido<br>
      Año:1908<br>
      Técnica:Óleo sobre tela<br>
      Medidas:50 x 40 cm.<br>
      Colección Museo de Historia Mexicana<br>
    </p>
    <p>Durante el desarrollo de la batalla del 5 de mayo, el Gral. Zaragoza mantuvo informado de las operaciones al Ministro de Guerra, Gral. Miguel Blanco, así como al Presidente de la República el Lic. Benito Juárez, a través de telegramas.</p>
    <p>5:49 p.m.  “Las armas del Supremo Gobierno se han cubierto de gloria: el enemigo ha hecho esfuerzos supremos por apoderarse del Cerro de Guadalupe que atacó por el Oriente á derecha é izquierda durante tres horas: fue rechazado tres veces en completa dispersión… Calculo la pérdida del enemigo, que llegó hasta los fosos de Guadalupe, en su ataque, en 600 ó 7OO entre muertos y heridos; 400 habremos tenido nosotros”.</p>
    <p>Dos horas después, a las 7 con 3 minutos de la noche:</p>
    <p>"Señor Presidente.- Estoy muy contento con el comportamiento de mis Generales y soldados.—Todos se han portado bien.—Los franceses han "llevado una lección muy severa; pero en obsequio de la verdad diré: que se han batido como bravos, muriendo una gran parte de ellos en los fosos de las trincheras de Guadalupe. — Sea para bien, Sr. Presidente. " Deseo que nuestra querida Patria, hoy tan desgraciada, sea feliz y respetada de todas las Naciones”.</p>
    <h5>Ver más:</h5>
    <p>Fuente de la imagen: <a target="_blank" href="https://www.3museos.com/?pieza=zacapoaxtla-abatiendo-suavos">www.3museos.com</a></p>
    <p>Libro 5 de Mayo en Puebla: <a target="_blank" href="http://cdigital.dgb.uanl.mx/la/1080009043/1080009043.PDF">cdigital.dgb.uanl.mx</a></p>
    <p>Libro “Las razones de la Victoria”: <a target="_blank" href="https://inehrm.gob.mx/work/models/inehrm/Resource/440/1/images/5mayo.pdf">inehrm.gob.mx</a></p>

    <h3>
      Gral. Ignacio Zaragoza<br>
      (1829 - 1862)
    </h3>
    <img @click="imageClicked(0)" src="galerias/sala2/S2_G6_SUB.jpg" class="mainphoto"/>
    <p class="photo-description">Título: <b>Gral. Ignacio Zaragoza</b><br>
      Autor: Anónimo <br>
      Año: S. XIX <br>
      Técnica: Óleo sobre tela<br>
      Medidas: 157 x 110 cms<br>
      Colección: Museo Regional “Casa de Alfeñique”<br>
    </p>
    <br>
    <p>Ignacio Zaragoza Seguín nació en 1824 en Bahía del Espíritu Santo, entonces territorio del estado de Coahuila, hoy parte del estado de Texas.</p>
    <p>Realizó sus primeros estudios en Matamoros, Tamps. y posteriormente en Monterrey, donde ingresó al Seminario, pero ante su falta de vocación se dedicó al comercio, logró ser aceptado en las milicias cívicas o guardias nacionales, finalmente pudo ser reclutado en el ejército en 1853, participando en la lucha liberal contra Santa Anna. Su carrera fue meteórica pues en 1859, durante la Guerra de Reforma, alcanzó el grado de general, ya casado con doña Rafaela Padilla. En 1860 participó en acciones contra los conservadores en Veracruz, Guadalajara y Zacatecas. Su calidad y disciplina le alcanzaron el puesto de Secretario de Guerra, ministerio que dejó cuando el presidente Juárez le solicitó hacerse cargo y organizar al Ejército de Oriente, ante la amenaza inminente del ejército francés.</p>
    <p>En el desempeño de esta encomienda logró el 5 de mayo de 1862, la inolvidable victoria de las armas nacionales, aunque al poco tiempo encontró la muerte por una infección entonces incurable el 8 de septiembre de ese año.</p>
    <h5>Ver más:</h5>
    <p>Biografía del General Zaragoza: <a target="_blank" href="https://www.cndh.org.mx/noticia/nace-el-general-ignacio-zaragoza-heroe-de-la-batalla-de-puebla-vencio-al-ejercito-invasor">www.cndh.org.mx</a></p>
    
    <h3>El enfrentamiento contra el ejército francés</h3>
    <img @click="imageClicked(2)" src="galerias/sala2/S2_G6_SUB2.jpg" class="mainphoto"/>
    <p class="photo-description">Título: <b>Una escena del asalto del Cerro de Guadalupe el 5 de mayo de 1862</b><br>
      Autor: Constantino Escalante<br>
      Año: S. XIX <br>
      Técnica: Litografía en Blanco y Negro<br>
      Medidas: 22 x 25 cm<br>
      Colección: Álbum de las Glorias Nacionales<br>
    </p>
  </div>
</template>

<script>
export default {
  name: "s22g06",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    },
  },
  components: {},
  props: {},
  mounted() {},
};
</script>
